import clsx from 'clsx';
import {flexRender, Header} from '@tanstack/react-table';

interface TableHeaderProps<T> {
    header: Header<T, unknown>;
}
const TableHeader = <T,>({header}: TableHeaderProps<T>): JSX.Element => {
    return (
        <th
            key={header.id}
            colSpan={header.colSpan}
            scope="col"
            className={clsx({
                'table-sort-desc': header.column.getIsSorted() === 'desc',
                'table-sort-asc': header.column.getIsSorted() === 'asc',
            })}
            style={{
                whiteSpace: 'nowrap',
                ...(header.column.columnDef.size !== undefined ? { width: header.column.columnDef.size } : {}),
            }}
        >
            {header.isPlaceholder ? null : (
                <span
                    {...{
                        className: header.column.getCanSort() ? 'cursor-pointer select-none' : '',
                        onClick: header.column.getToggleSortingHandler(),
                    }}
                >
                    {flexRender(header.column.columnDef.header, header.getContext())}
                </span>
            )}
        </th>
    );
};

export default TableHeader;
